import React, { useEffect, useState } from 'react';
import './style.scss';
import {
  loginOtpUserAction,
  loginUserAction,
  selectUser,
} from '@/redux-config/entities/user';
import { useAppDispatch, useAppSelector } from '@/redux-config/hooks';
import { CustomInput } from '@/components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoginApi } from '@/api';
import ReactHtmlParser from 'react-html-parser';
import { selectLanguage } from '@/redux-config/entities/language';

const logo = require('@/assets/image/logo.png');

export const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const { i18n, t } = useTranslation();
  const language = useAppSelector(selectLanguage);
  useEffect(() => {
    i18n.changeLanguage(language);
  }, []);

  const phoneNumberRegex = /^(09\d{9})$/;
  const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);

  const [phone, setPhone] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const [isWithPass, setIsWithPass] = useState<boolean>(true);
  const [isOtpSend, setIsOtpSend] = useState<boolean>(false);
  const [otpCode, setOtpCode] = useState<string>('');

  const [captcha, setCaptcha] = useState<string>('');
  const [captchaID, setCaptchaId] = useState<string>('');
  const [captchaCode, setCaptchaCode] = useState<string>('');

  useEffect(() => {
    if (!isWithPass) {
      handleGetCaptcha();
    }
  }, [isWithPass]);

  useEffect(() => {
    if (user.accessToken && user.accessToken.length > 0) {
      navigate('/');
    }
  }, [user]);

  const handleGetCaptcha = () => {
    LoginApi.GetCaptcha()
      .then((data) => {
        setCaptchaId(data.id);
        setCaptcha(data.captcha);
      })
      .catch((err) => {});
  };

  const handleOtpSend = () => {
    LoginApi.SendOtp(phone, captchaID, captchaCode)
      .then((data) => {
        setIsOtpSend(true);
      })
      .catch((err) => {
        handleGetCaptcha();
      });
  };

  const handleLogin = () => {
    dispatch(loginUserAction({ phone: phone, password: password }))
      .then((data) => {})
      .catch((err) => {});
  };

  const handleLoginWithOtp = () => {
    dispatch(loginOtpUserAction({ phone: phone, otp: otpCode }))
      .then((data) => {})
      .catch((err) => {});
  };

  return (
    <div className="loginContainer px-3">
      <div className="container bg-custom-white shadow-lg rounded p-3 p-sm-5 d-flex flex-column flex-md-row">
        <div
          className={
            'col-12 col-md-6 d-flex flex-column justify-content-center align-items-center'
          }
        >
          <img src={logo} className={'w-50 h-50 object-fit-contain'} />
        </div>
        <div className="d-flex flex-column col-12 col-md-6 gap-3" dir={'rtl'}>
          <h3>{t('login')}</h3>
          <div className={'d-flex flex-column w-100'}>
            <label>{t('phoneNumber')}</label>
            <CustomInput
              type={'text_number'}
              name={'phone number'}
              className={`custom-input ${
                phone.length === 0
                  ? 'border-reg'
                  : phoneNumberRegex.test(phone)
                    ? 'border-success'
                    : 'border-error'
              }`}
              dir={phone.length === 0 ? 'rtl' : 'ltr'}
              placeholder={t('phoneNumber') + ''}
              value={phone}
              onChange={setPhone}
            />
          </div>
          {isWithPass ? (
            <>
              <div className={'d-flex flex-column w-100'}>
                <label>{t('password')}</label>
                <CustomInput
                  type={'password'}
                  name={'password'}
                  className={`custom-input ${
                    password.length === 0
                      ? 'border-reg'
                      : passwordRegex.test(password)
                        ? 'border-success'
                        : 'border-error'
                  }`}
                  placeholder={t('password') + ''}
                  value={password}
                  onChange={setPassword}
                />
              </div>
              <div>
                <button
                  onClick={() => {
                    handleLogin();
                  }}
                  disabled={
                    !(
                      phoneNumberRegex.test(phone) &&
                      passwordRegex.test(password)
                    )
                  }
                  className={'prm-btn px-4 rounded-2'}
                >
                  {t('login')}
                </button>
              </div>
              <span
                onClick={() => {
                  setIsWithPass(false);
                }}
                className={'red2-text g-cursor-pointer'}
              >
                {t('loginWithOtp')}
              </span>
            </>
          ) : (
            <>
              {isOtpSend ? (
                <>
                  <div className={'d-flex flex-column w-100'}>
                    <label>{t('otp')}</label>
                    <CustomInput
                      type={'number'}
                      name={'OTP code'}
                      className={`custom-input text-center ${
                        otpCode.length === 0
                          ? 'border-reg'
                          : otpCode.length === 6
                            ? 'border-success'
                            : 'border-error'
                      }`}
                      placeholder={t('OTP') + ''}
                      value={otpCode}
                      onChange={(data: string) => {
                        if (data.length <= 6) {
                          setOtpCode(data);
                        }
                      }}
                    />
                  </div>
                  <div>
                    <button
                      onClick={() => {
                        handleLoginWithOtp();
                      }}
                      disabled={
                        !(phoneNumberRegex.test(phone) && otpCode.length === 6)
                      }
                      className={'prm-btn px-4 rounded-2'}
                    >
                      {t('login')}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={
                      'd-flex flex-row align-items-center justify-content-between'
                    }
                  >
                    {ReactHtmlParser(captcha)}
                    <CustomInput
                      type={'text_number'}
                      name={'Captcha code'}
                      className={`custom-input text-center ${
                        captchaCode.length === 0
                          ? 'border-reg'
                          : captchaCode.length === 4
                            ? 'border-success'
                            : 'border-error'
                      }`}
                      placeholder={t('Code') + ''}
                      value={captchaCode}
                      onChange={(data: string) => {
                        if (data.length <= 4) {
                          setCaptchaCode(data);
                        }
                      }}
                    />
                  </div>
                  <div>
                    <button
                      disabled={
                        !(
                          captchaCode.length === 4 &&
                          phoneNumberRegex.test(phone)
                        )
                      }
                      onClick={() => {
                        handleOtpSend();
                      }}
                      className={'prm-btn px-4 rounded-2'}
                    >
                      {t('SendOtp')}
                    </button>
                  </div>
                </>
              )}

              <span
                onClick={() => {
                  setIsWithPass(true);
                }}
                className={'red2-text g-cursor-pointer'}
              >
                {t('loginWithPassword')}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
